// icon:arrows_vertical | Linea Iconset https://linea.io/ | Benjamin Sigidi
import * as React from "react";

function SplitFloorTool(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="currentColor"
      height="1.5em"
      width="1.5em"
      {...props}
    >
      <path
        fill="none"
        stroke="currentColor"
        strokeLinejoin="bevel"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M39 8l-7-7-7 7M25 56l7 7 7-7"
      />
      <path
        fill="none"
        stroke="currentColor"
        strokeMiterlimit={10}
        strokeWidth={2}
        d="M32 63V1"
      />
    </svg>
  );
}

export default SplitFloorTool;
